document.addEventListener('DOMContentLoaded', function() {
    var cartDrawerOverlay = document.querySelector("#cart-drawer-overlay");
    document.addEventListener("click", function(event) {
        var body = document.body;
        if (body.classList.contains("cart-drawer-open") && cartDrawerOverlay.contains(event.target)) {
            closeCart();
        }
    });
})

function sellingPlanUpdate(elem){ 
    const selectedPlan = elem.value;
    if (selectedPlan == 'one_time') {
        return
    }
    const quantity = elem.dataset.quantity;
    const variantId = elem.dataset.variantId;
    const elemIndex = elem.dataset.index;
    const itemKey = elem.dataset.itemKey;
    changeProduct(selectedPlan, quantity, variantId, elemIndex, itemKey);
}

function changeProduct(selectedPlan, quantity, variantId, elemIndex, itemKey) {
    let formData = {
         'id': itemKey,
         'quantity': quantity,
         'selling_plan': selectedPlan
       };
       fetch(window.Shopify.routes.root + 'cart/change.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
        renderItem(variantId, elemIndex, itemKey);
        // reloadCart();
        return response.json();
    })
    .catch((error) => {
           console.log('not product updated');
         console.error('Error:', error);
       });
}

function renderItem(variantId, elemIndex, oldKey){
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.send();
    xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) { 
            var cartData = JSON.parse(xhr.responseText);
            var items = cartData.items;
            console.log('cartData ', cartData);
            var repitedElement = document.querySelectorAll(`li.cart-item[data-cartitem-id="${variantId}"]`);
            if (repitedElement.length > 1){
                repitedElement.forEach((elem)=>{
                    if (elem.dataset.cartitemKey != oldKey) {
                        // elem.remove();
                    }
                });
            }
            items.forEach(function(item) {
                if (item.id === parseInt(variantId)) {
                    document.querySelector(`li.cart-item[data-cartitem-index="${elemIndex}"] .cart-item--line-item-subscriptions`).textContent = item.selling_plan_allocation.selling_plan.name;
                    document.querySelector(`li.cart-item[data-cartitem-index="${elemIndex}"] .cart-item--line-item-subscriptions`).style.display = "block";
                    document.querySelector(`li.cart-item[data-cartitem-index="${elemIndex}"] .selling_plan_options`).style.display = "none";
                    document.querySelector(`li.cart-item[data-cartitem-index="${elemIndex}"] .quantity-selector__input`).value = item.quantity;
                    document.querySelector(`li.cart-item[data-cartitem-index="${elemIndex}"] .cart-item--content-price .money`).textContent = Shopify.formatMoney(item.price);
                    document.querySelector(`li.cart-item[data-cartitem-index="${elemIndex}"] .cart-item__total .money`).textContent = Shopify.formatMoney(item.final_line_price);
                    document.querySelector(`li.cart-item[data-cartitem-index="${elemIndex}"]`).dataset.cartitemKey = item.key;
                    document.querySelector(`li.cart-item[data-cartitem-index="${elemIndex}"] quantity-selector .quantity-selector__label`).setAttribute('for','updates_' + item.key);
                    document.querySelector(`li.cart-item[data-cartitem-index="${elemIndex}"] quantity-selector .quantity-selector__input`).setAttribute('id', 'updates_' + item.key);
                }
            });
            document.querySelector(`.cart-subtotal .saw-cart-original-total .money`).textContent = Shopify.formatMoney(cartData.total_price);
        } else {
            console.error('Failed to fetch cart data:', xhr.statusText);
        }
    };
    xhr.onerror = function() {
        console.error('Network error occurred');
    };
}
function displaySubscriptionOptions(elem){
    elem.style.display = 'none';
    elem.nextElementSibling.style.display = 'block';
}
function openCart(){
    let body = document.querySelector('body');
    body.classList.remove('cart-drawer-closed');
    body.classList.add('cart-drawer-open');
    $('#cart-drawer-overlay').fadeIn();
    if( typeof easylockdown === 'object') {
        easylockdown.initFilters();
        easylockdown.hideAllLinks();
    }
}

function closeCart(){
    let body = document.querySelector('body');
    body.classList.remove('cart-drawer-open');
    body.classList.add('cart-drawer-closed');
    $('#cart-drawer-overlay').fadeOut();
}

function reloadCart(){
    $('#side-cart-id').load(document.URL +  ' #side-cart-id', function(response, status, xhr) {
        if (status === "success") {
            const sectionElement = document.querySelector('[data-section-id="cart-drawer"]');
            const sections = new Sections();
            sections.register('static-cart', section => new StaticCart(section));
        } else {
            console.error('Error loading side cart:', xhr.status, xhr.statusText);
        }
    }); 
}